// extracted by mini-css-extract-plugin
export var active = "NDSTooltip-module--active--e9027";
export var button = "NDSTooltip-module--button--c3e29";
export var close = "NDSTooltip-module--close--731fc";
export var content = "NDSTooltip-module--content--ce22b";
export var fade = "NDSTooltip-module--fade--928c6";
export var icon = "NDSTooltip-module--icon--3543f";
export var lottieAnimation = "NDSTooltip-module--lottieAnimation--0bad8";
export var tooltip = "NDSTooltip-module--tooltip--d7c9c";
export var tooltipRoot = "NDSTooltip-module--tooltipRoot--a534d";
export var tooltipText = "NDSTooltip-module--tooltipText--3c3d1";